import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { BackendErrorResponse } from "app/services/api/types/common/models/ErrorResponse";

export default function parseRtkError(
  error: FetchBaseQueryError | SerializedError | string | undefined,
  statusOverride?: Record<number, string>,
): string {
  if (!error) return "";
  if (typeof error === "string") return error;
  if ("status" in error && statusOverride && statusOverride[error.status]) {
    return statusOverride[error.status];
  }
  if (error && "data" in error && error.data) {
    return typeof error.data === "object" && "message" in error.data
      ? ((error.data?.message as string) ?? "")
      : "";
  }
  if (error && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return "";
}

export function handleBackendError(
  e: unknown,
  setError: (
    field: keyof any,
    error: { type: string; message?: string },
  ) => void,
  setErrorMessage?: (message: string) => void,
): boolean {
  const errorResponse = e as BackendErrorResponse;
  if (errorResponse.data.errors) {
    Object.entries(errorResponse.data.errors).forEach(([field, messages]) => {
      if (messages.length > 0) {
        setError(field as keyof any, {
          type: "manual",
          message: messages[0],
        });
      }
    });
    if (setErrorMessage && errorResponse.data.message) {
      setErrorMessage(errorResponse.data.message);
    }
  }
  return false;
}
